class ReactFilterHouseholdHead extends React.Component {
    constructor(props) {
        super(props);
    }
    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        var value = this.refs.combo.getValues();
        if(value=='any'){
            value=null;
        }
        return {
            value:value
        };
    }
    
    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.refs.combo.clearValues()
    }
    
    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if(values.value){
            this.refs.combo.setValues({
                value:values.value
            })
        }else{
            this.clearValues();
        }
    }
    
    render() {

        var value = this.props.settings.value;
        if(!value && value!==0){
            value = 'any';
        }

        return React.createElement(ReactFilterCombo,{
            ref:'combo',
            singleSelect:true,
            label: this.props.label,
            value:value,
            idField:'value',
            displayField:'text',
            applyFilters: this.props.applyFilters,
            clearFilters: this.props.clearFilters,
            loadGrid: this.props.loadGrid,
            records:[{
                text:'Yes',
                value:1
            },{
                text:'No',
                value:0
            },{
                text:'Any',
                value:'any'
            }]
        });
    }
}

ReactFilterHouseholdHead.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.object,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
};